/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";

const Footer = () => (
  <footer>
    <p className="text-dark">Fenix Outdoor International</p>
    <p>© 2021 All Rights Reserved</p>
  </footer>
);

export default Footer;
